import { ReactNode } from "react";
import { TCarbonComponentSizeProps } from "../../interfaces-and-types";

import { View } from "./View";

export interface ISwitchAppButtonProps {
  onClick: () => void;
  title?: string | null;
  isLoading?: boolean;
  children: ReactNode;
  disabled?: boolean;
  className?: string;
  kind?:
    | "primary"
    | "secondary"
    | "tertiary"
    | "success"
    | "danger"
    | "warning";
  size?: TCarbonComponentSizeProps;
}

export const SwitchAppButton = (props: ISwitchAppButtonProps) => {
  return <View {...props} />;
};
